import { AlertCircle } from 'lucide-react';
import { HOUSEHOLD_LABELS, INTERVAL_LABELS, formatMoney } from './helper';

// The card was declined, or the tab was closed mid-checkout. The enrollment row
// exists and the invoice is open, so the practice sees "waiting on first
// payment" and the patient cannot start a different plan until this one is
// settled or Stripe expires it.
const UnpaidCheckout = ({ enrollment, busy = false, onPay, onAbandon }) => {
  const { plan_name, household_type, interval, price_dollars } = enrollment || {};

  return (
    <div className="animate-slide-up rounded-xl border border-amber-100 bg-amber-50 p-4">
      <div className="flex items-start gap-4">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-amber-200 bg-white text-amber-600">
          <AlertCircle size={20} />
        </span>

        <div className="min-w-0">
          <p className="text-[15px] font-bold text-secondary-900">Your payment didn't go through</p>
          <p className="mt-1 text-xs leading-relaxed text-amber-800">
            Your {plan_name} membership is reserved but not active yet — nothing has been charged,
            and member pricing doesn't start until it is. Enter a card to finish joining.
          </p>
        </div>
      </div>

      <div className="mt-4 flex flex-col gap-3 border-t border-amber-200/70 pt-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm font-bold text-secondary-900">
          {plan_name} · {HOUSEHOLD_LABELS[household_type] || household_type}
          {interval && <span className="font-medium text-secondary-500"> · {INTERVAL_LABELS[interval]}</span>}
          {price_dollars != null && (
            <span className="font-medium text-secondary-500"> · {formatMoney(price_dollars)}</span>
          )}
        </p>

        <button
          type="button"
          onClick={onPay}
          disabled={busy}
          className="btn h-11 min-h-11 shrink-0 gap-2 rounded-xl border-0 bg-teamcare-blue px-5 text-sm font-semibold text-white hover:bg-teamcare-blue-dark disabled:opacity-60"
        >
          {busy ? <span className="loading loading-spinner loading-sm" /> : 'Finish payment'}
        </button>
      </div>

      {/* Without this the patient is stuck: the API counts a pending row as
          enrolled, so no other plan can be bought until Stripe expires it. */}
      <button
        type="button"
        onClick={onAbandon}
        disabled={busy}
        className="mt-3 text-xs font-semibold text-amber-800/70 underline underline-offset-2 hover:text-amber-900 disabled:opacity-60"
      >
        Never mind — don't join
      </button>
    </div>
  );
};

export default UnpaidCheckout;
